
import { initSlickCarousels } from "./../js/slickCarousel/initSlickCarousels";

initSlickCarousels("carousel");
